import React, { useState } from 'react';
import { Card, Form } from 'react-bootstrap';
import { FaCircleInfo } from 'react-icons/fa6';
import StatusBadge from '../StatusBadge/StatusBadge';
import { IntegrationStatus } from '../../constants/integrationStatus';
import {
  CardWrapper,
  CardHeaderContent,
  IconContainer,
  TitleSection,
  CardTitle,
  TitleRow,
  Category,
  Description,
  CardActions,
  ConfigureButton,
  InfoIconWrapper,
  CustomTooltip,
  TooltipContent,
} from './IntegrationCard.styles';

const IntegrationCard = ({
  id,
  name,
  description,
  category,
  icon: Icon,
  status,
  onToggle,
  onConfigure,
  usageDescription,
  permissions,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const hasTooltipContent = usageDescription || permissions?.length > 0;

  return (
    <CardWrapper $upcoming={status === IntegrationStatus.UPCOMING}>
      <Card.Header>
        <CardHeaderContent>
          <IconContainer $active={status === IntegrationStatus.CONNECTED}>
            <Icon />
          </IconContainer>
          <TitleSection>
            <TitleRow>
              <CardTitle>{name}</CardTitle>
              {hasTooltipContent && (
                <InfoIconWrapper
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                >
                  <FaCircleInfo />
                  {showTooltip && (
                    <CustomTooltip>
                      <TooltipContent>
                        {usageDescription && (
                          <div className='tooltip-section'>
                            <div className='tooltip-title'>How we use this integration</div>
                            <div className='tooltip-text'>{usageDescription}</div>
                          </div>
                        )}
                        {permissions?.length > 0 && (
                          <div className='tooltip-section'>
                            <div className='tooltip-title'>Permissions required</div>
                            <ul className='tooltip-list'>
                              {permissions.map((permission, index) => (
                                <li key={index}>{permission}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </TooltipContent>
                    </CustomTooltip>
                  )}
                </InfoIconWrapper>
              )}
            </TitleRow>
            <Category>{category}</Category>
          </TitleSection>
          <StatusBadge status={status} />
        </CardHeaderContent>
      </Card.Header>
      <Card.Body>
        <Description>{description}</Description>

        <hr />

        <CardActions>
          <ConfigureButton
            disabled={status === IntegrationStatus.DISCONNECTED || status === IntegrationStatus.UPCOMING}
            onClick={() => onConfigure?.(id)}
          >
            Configure
          </ConfigureButton>
          <Form.Check
            type='switch'
            id={`integration-switch-${id}`}
            checked={status === IntegrationStatus.CONNECTED}
            onChange={() => onToggle?.(id)}
            disabled={status === IntegrationStatus.UPCOMING}
          />
        </CardActions>
      </Card.Body>
    </CardWrapper>
  );
};

export default IntegrationCard;
